import { calculatePagination } from '../../utils/helper';

export const initialStateSchedule = {
    scheduleRequests: [],
    availabilityRequests: [],
    absenceTypes: [],
    loading: false,
    errorMessage: null,
    pageInfo: {},
    availabilityPageInfo: {},
    perPageLimit: 25,
};

export const ScheduleReducer = (state = initialStateSchedule, action) => {
    switch (action.type) {
        case 'REQUEST_SCHEDULE':
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };
        case 'ABSENCE_TYPES_SUCCESS':
            return {
                ...state,
                absenceTypes: action.payload,
                loading: false,
            };
        case 'SCHEDULE_REQUESTS_SUCCESS':
            return {
                ...state,
                scheduleRequests: action.payload,
                pageInfo: calculatePagination(action.payload, state.perPageLimit),
                loading: false,
            };
        case 'CREATE_SCHEDULE_REQUEST_SUCCESS': {
            const updated = [action.payload, ...state.scheduleRequests];
            return {
                ...state,
                scheduleRequests: updated,
                pageInfo: calculatePagination(updated, state.perPageLimit),
                loading: false,
            };
        }
        case 'AVAILABILITY_REQUESTS_SUCCESS':
            return {
                ...state,
                availabilityRequests: action.payload,
                availabilityPageInfo: calculatePagination(action.payload, state.perPageLimit),
                loading: false,
            };
        case 'CREATE_AVAILABILITY_REQUEST_SUCCESS': {
            const updated = [action.payload, ...state.availabilityRequests];
            return {
                ...state,
                availabilityRequests: updated,
                availabilityPageInfo: calculatePagination(updated, state.perPageLimit),
                loading: false,
            };
        }
        case 'UPDATE_SCHEDULE_REQUEST_SUCCESS': {
            const updatedTimeOff = state.scheduleRequests.map((r) => (r.id === action.payload.id ? action.payload : r));
            const updatedAvail = state.availabilityRequests.map((r) =>
                r.id === action.payload.id ? action.payload : r
            );
            return {
                ...state,
                scheduleRequests: updatedTimeOff,
                pageInfo: calculatePagination(updatedTimeOff, state.perPageLimit),
                availabilityRequests: updatedAvail,
                availabilityPageInfo: calculatePagination(updatedAvail, state.perPageLimit),
                loading: false,
            };
        }
        case 'DELETE_SCHEDULE_REQUEST_SUCCESS': {
            const filteredTimeOff = state.scheduleRequests.filter((r) => r.id !== action.payload);
            const filteredAvail = state.availabilityRequests.filter((r) => r.id !== action.payload);
            return {
                ...state,
                scheduleRequests: filteredTimeOff,
                pageInfo: calculatePagination(filteredTimeOff, state.perPageLimit),
                availabilityRequests: filteredAvail,
                availabilityPageInfo: calculatePagination(filteredAvail, state.perPageLimit),
                loading: false,
            };
        }
        case 'SCHEDULE_ERROR':
            return {
                ...state,
                errorMessage: action.payload,
                loading: false,
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
